import { US_STATES } from "@/lib/usStates";

// Canonical production origin. Canonicals/OG always point here (never the preview host),
// so only production gets indexed.
export const SITE_URL = "https://travelsports.info";
export const SITE_NAME = "TravelSports.info";

export function stateSlug(name) {
    return String(name || "").toLowerCase().replace(/\s+/g, "-");
}

// Circuit slug = "squished" name, no spaces/punctuation (matches backend slug_utils).
// "Prep Girls Hoops" -> "prepgirlshoops"
export function circuitSlug(name) {
    return String(name || "").toLowerCase().replace(/[^a-z0-9]+/g, "");
}

// "texas" -> "TX"
export const STATE_SLUG_TO_ABBR = Object.fromEntries(
    US_STATES.map(([abbr, name]) => [stateSlug(name), abbr])
);
// "TX" -> "Texas"
export const ABBR_TO_STATE = Object.fromEntries(
    US_STATES.map(([abbr, name]) => [abbr, name])
);

export function absUrl(path) {
    const p = String(path || "/");
    return `${SITE_URL}${p.startsWith("/") ? "" : "/"}${p}`;
}
